import { UIElement } from '../ui-element';

/** Container for composed `<media-time>` and `<media-time-separator>` displays. */
export class TimeGroupElement extends UIElement {
  static readonly tagName = 'media-time-group';

  // Future: Could provide context for hoursDisplay to children via Lit context
}
